/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import { getTheme } from "@fluentui/react";

const theme = getTheme();

export const CommandBarWrapper = styled.div`
  margin-top: 0.5rem !important; // Needed to override a stack style
`;

export const TableWrapper = styled.div<{ commandBarButtonPresent: boolean }>`
  border: ${`1px solid ${theme.palette.neutralTertiaryAlt}`};
  border-radius: 0.5rem;
  padding: 0.6rem 1.5rem;
  boxshadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  margin: ${(props) =>
    props.commandBarButtonPresent
      ? "0.5rem 1rem 1rem 1rem !important"
      : "1rem !important"}; // Needed to override a stack style
`;
